import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import Image from 'next/image';
import { IResourceData } from 'utils/globalTypes';
import { defaultLoader } from 'utils/images';
import { getValidUrl } from 'utils/urlUtils';

import s from './UnsubscribeFeed.module.scss';

interface UnsubscribeFeedProps {
  images: IResourceData[];
  className?: string;
}

const UnsubscribeFeed = ({ images, className }: UnsubscribeFeedProps) => {
  return (
    <section className={cn(s.UnsubscribeFeed, className)}>
      <Typography mb={3} variant="h3" sx={{ fontWeight: 'bold' }}>
        {'Real Estate Investment insights you&apos;d no longer hear about...'}
      </Typography>
      <div className={s.UnsubscribeFeed__images}>
        {images.map((image, index) => (
          <Link
            color="inherit"
            underline="hover"
            className={s.UnsubscribeFeed__imageHolder}
            target="_blank"
            key={image?.name ?? index}
            href={image?.description ?? ''}
            rel="noreferrer"
          >
            <Image
              className={s.UnsubscribeFeed__image}
              loader={defaultLoader}
              style={{ objectFit: 'fill' }}
              width={208}
              height={106}
              quality={50}
              src={getValidUrl(image?.url) || ''}
              alt={image?.description ?? ''}
            />
            <span className={s.UnsubscribeFeed__caption}>{image?.name}</span>
          </Link>
        ))}
      </div>
      <div className={s.UnsubscribeFeed__footer}>
        <Link color="text.secondary" href="https://www.usremsecurities.com/blog/" target="_blank">
          {'Show more insights'}
        </Link>
      </div>
    </section>
  );
};

export default observer(UnsubscribeFeed);
